import { toErrorWithMessage } from "./toErrorWithMessage";

/**
 * 
 * @param {unknown} error 
 * @returns {string} error message
 */
export const getErrorMessage = (error: unknown): string => toErrorWithMessage(error).message;